import React, { useEffect, useMemo, useRef, useState } from "react";
import vizIcon from "../assets/logos/vizwalk.png";
import yt1 from "../assets/logos/yt1.png";
import vz1 from "../assets/logos/vz1.png";
import indiaIcon from "../assets/icons/flag-in.png";
import usIcon from "../assets/icons/flag-us.png";
import searchIcon from "../assets/icons/search.png";

import { useAuth } from "../features/auth";
import Navbar from "../components/Navbar.jsx";
import { useProjects } from "../features/catalog";
import ImageWithFallback from "../components/ImageWithFallback";
import { projectPageUrl } from "../lib/projectUrl";

import "../features/catalog/testimonials-marquee.css";
import "../features/catalog/catalog.css";

import Footer from "../components/Footer.jsx";

import demoIcon from "../assets/icons/view-demo.png";
import arrowPng from "../assets/icons/arrow.png";

import { useVideoModal } from "../components/VideoModalContext";

import { useNavigate, useLocation } from "react-router-dom";

const HERO_MP4 =
  "https://s3-vizwalk-dev.flipspaces.app/uploads/Vizwalk+background+2.mov";

function getRegionFromPath(pathname = "") {
  const parts = pathname.split("/").filter(Boolean);
  const first = (parts[0] || "").toLowerCase();
  return first === "us" ? "us" : "in";
}

const norm = (s = "") =>
  String(s).toLowerCase().replace(/_/g, " ").replace(/\s+/g, " ").trim();

function formatSqft(n = "") {
  const s = String(n).replace(/,/g, "").trim();
  const val = Number(s);
  if (Number.isFinite(val) && val > 0) return `${val.toLocaleString()} sqft`;
  return n || "";
}

function normalizeServer(v = "") {
  const s = norm(v);
  if (s.includes("us")) return "us";
  if (s.includes("india") || s === "in") return "india";
  return "";
}

/** ====== FEATURED CARD ====== */
function FeaturedCard({
  item,
  onOpenProject,
  onOpenVizdom,
  onOpenYoutube,
  onOpenDemo,
}) {
  const hasYoutube = Boolean(String(item.youtube || "").trim());
  const hasVizdom = Boolean(String(item.vizdomId || "").trim());
  const hasDemo = Boolean(String(item.demoLink || "").trim());

const openDemo = (e) => {
  e.stopPropagation();
  onOpenDemo?.();
};

 const openYoutube = (e) => {
  e.stopPropagation();
  onOpenYoutube?.();
};

  return (
    <article className="fpProjectCard">
      <div className="fpCardMedia">
        <ImageWithFallback
          className="fpCardImg"
          src={item.thumb}
          alt={item.name}
        />

        <button
          className="fpViewPill"
          onClick={(e) => {
            e.stopPropagation();
            onOpenProject();
          }}
          type="button"
        >
          View Project
          <img
            className="fpViewPillArrow"
            src={arrowPng}
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>

      <div className="fpCardDetails">
        <h3 className="fpProjectName">{item.name || "Project"}</h3>

        <p className="fpProjectMeta">
          {(item.constructionType || item.industry || "—")} |{" "}
          {formatSqft(item.areaSqft || "")}
        </p>

        <div className="fpCardFooter">
          {hasYoutube ? (
            <button
              className="fpFooterSquare"
              onClick={openYoutube}
              type="button"
              aria-label="Open YouTube"
            >
              <img src={yt1} alt="" className="fpFooterSquareImg fpYtImg" />
            </button>
          ) : null}

          {hasVizdom ? (
            <button
              className="fpFooterSquare"
              onClick={(e) => {
                e.stopPropagation();
                onOpenVizdom();
              }}
              type="button"
              aria-label="Open Vizdom"
            >
              <img src={vz1} alt="" className="fpFooterSquareImg" />
            </button>
          ) : null}

          {hasDemo ? (
            <button className="fpFooterDemoBtn" onClick={openDemo} type="button">
              <img src={demoIcon} alt="" className="fpDemoIcon" />
              <span>View Demo</span>
            </button>
          ) : null}
        </div>
      </div>
    </article>
  );
}

function TestimonialsOnly() {
  const testimonials = [
    {
      name: "Santosh Upadhyay",
      role: "BFIL (Bharat financial bank)",
      quote:
        "Our new workspace embodies innovation, creativity, and forward-thinking. Huge thanks to Flipspaces for their expertise, dedication, and swift transformation!",
    },
    {
      name: "Vivek Khemani",
      role: "Quantiphi",
      quote:
        "Flipspaces was a one-stop solution for our office expansion, using VR technology to perfectly visualize and execute our vision.",
    },
    {
      name: "Pankaj Tripathi",
      role: "B/S/H",
      quote:
        "Flipspaces designed our Mumbai, Hyderabad, Chennai, and Bangalore offices with open spaces, natural light, and a vibrant, modern work environment.",
    },
    {
      name: "Vishal Shah",
      role: "Talakunchi",
      quote:
        "Right from understanding our expectations to the design and execution of the entire project, Flipspaces handled everything with utmost professionalism. We are extremely happy with the outcome",
    },
    {
      name: "Kunal Shah",
      role: "Honest",
      quote:
        "Flipspaces transformed my restaurant with creativity, precision, and exceptional craftsmanship. Special thanks to Richard for seamless communication and prompt support!",
    },
    {
      name: "Vishal Soni",
      role: "Taaza",
      quote:
        "Flipspaces delivered our project on time with professionalism and excellence. Grateful for their hard work and eager to collaborate again!",
    },
    
  ];

  const loop = [...testimonials, ...testimonials];

  return (
    <section className="tsSection">
      <div className="tsInner">
        <div className="tsKicker">WHAT OUR CLIENTS SAY</div>

        <h2 className="tsTitle">
          Trusted by leading businesses across industries for exceptional workspace
          transformations
        </h2>

        <div className="tsMarquee">
          <div className="tsTrack">
            {loop.map((t, idx) => (
              <div className="tsCard" key={idx}>
                <div className="tsName">{t.name}</div>
                <div className="tsRole">{t.role}</div>
                <div className="tsQuote">“{t.quote}”</div>
              </div>
            ))}
          </div>

          <div className="tsFadeL" />
          <div className="tsFadeR" />
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const currentRegion = getRegionFromPath(location.pathname);

  const { projects, loading } = useProjects("Showcase");

  const [selectedServer, setSelectedServer] = useState(
    currentRegion === "us" ? "us" : "india"
  );
  const [activeCategory2, setActiveCategory2] = useState("All");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [showAll2, setShowAll2] = useState(false);

  const { openVideo } = useVideoModal();

  const featuredProjectsRef = useRef(null);

  useEffect(() => {
    setSelectedServer(currentRegion === "us" ? "us" : "india");
  }, [currentRegion]);

  useEffect(() => {
    setActiveCategory2("All");
    setSearchQuery2("");
    setShowAll2(false);
  }, [selectedServer]);

  // Adapts the unified `Project` shape (src/features/catalog/useProjects.js) to the local card
  // shape this page has always rendered, so nothing below this needs to change.
  const items = useMemo(
    () =>
      projects.map((p) => ({
        id: p.id,
        server: normalizeServer(p.server),
        sbu: p.sbu,
        name: p.name,
        buildLabel: p.buildLabel,
        areaSqft: p.areaSqft ?? "",
        industry: p.industry,
        designStyle: p.designStyle,
        thumb: p.thumbnail,
        youtube: p.media.find((m) => m.kind === "walkthrough")?.urls[0] || "",
        vizdomId: p.vizdomId,
        constructionType: p.constructionType,
        demoLink: p.media.find((m) => m.kind === "demo")?.urls[0] || "",
      })),
    [projects]
  );

  const typeOptions = useMemo(() => {
    const set = new Set(["All"]);
    items.forEach((it) => {
      const t = String(it.constructionType || "").trim();
      if (t) set.add(t);
    });
    return Array.from(set);
  }, [items]);

  const filtered = useMemo(() => {
    const q = norm(searchQuery2);
    return items.filter((it) => {
      if (selectedServer && it.server && it.server !== selectedServer) return false;
      if (selectedServer && !it.server) return false;

      if (activeCategory2 !== "All") {
        const typeOk = String(it.constructionType || "").trim() === activeCategory2;
        if (!typeOk) return false;
      }

      if (!q) return true;
      const big = `${it.name} ${it.buildLabel} ${it.areaSqft} ${it.industry} ${it.designStyle} ${it.sbu}`;
      return norm(big).includes(q);
    });
  }, [items, selectedServer, activeCategory2, searchQuery2]);

  const handleOpenProject = (item) => {
    sessionStorage.setItem(
      "SG_BACK_URL",
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    );

    window.location.assign(projectPageUrl(currentRegion, item.id));
  };

  const handleOpenVizdom = (item) => {
    const id = String(item?.vizdomId || "").trim();
    if (!id) return;
    const url = `https://vizdom.flipspaces.app/user/project/${encodeURIComponent(id)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // if (loading) return <div style={{ ...sx.page, padding: 24 }}>Loading…</div>;

  return (
    <div style={sx.page}>
      <Navbar
        user={user}
        signOut={signOut}
        selectedServer={selectedServer}
        setSelectedServer={setSelectedServer}
      />

      <section className="hero2">
        <video
          className="hero2Video"
          src={HERO_MP4}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          controls={false}
        />
        <div className="hero2Overlay" />

        <div className="hero2Inner">
          <div className="hero2Kicker">CRAFTING IMMERSIVE EXPERIENCE</div>
          <div className="hero2Title">Bring Spaces To Life</div>

          <div className="hero2Desc">
            Interactive virtual walkthrough offering clients an <b>immersive experience with real-time</b>{" "}
            <b>design modifications</b> using Flipspaces&apos; integrated product library
          </div>

          <div className="hero2Btns">
            <button
  type="button"
  className="hero2Btn hero2BtnPrimary"
  onClick={() =>
    openVideo(
      "https://youtu.be/_-X8hoHd8Mc?si=Gc7GCiGZOmtLQ6Mv",
      "VizWalk Demo",
      "Interactive platform walkthrough",
      { type: "youtube" }
    )
  }
>
  <img src={yt1} alt="" className="hero2YTIconImg" aria-hidden="true" />
  <span>Watch Demo</span>
</button>

            <button
              type="button"
              className="hero2Btn hero2BtnSecondary"
              onClick={() => {
                featuredProjectsRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Explore Platform
            </button>
          </div>
        </div>
      </section>

      <section
  id="featured-projects"
  ref={featuredProjectsRef}
  className="fpSection"
>
        <div className="fpContainer">
          <div className="fpHeader">
            <div className="fpHeaderLeft">
              <div className="fpTitleRow">
                <div className="fpTitle">Featured Projects</div>

                <div className="fpServerBadge">
                  <img
                    src={selectedServer === "india" ? indiaIcon : usIcon}
                    alt=""
                    className="fpServerBadgeIcon"
                  />
                  <span className="fpServerBadgeText">
                    {selectedServer === "india" ? "India Server" : "US Server"}
                  </span>
                </div>
              </div>

              <div className="fpSub">
                Explore our projects showcasing tech-enabled interior design expertise
              </div>
            </div>
          </div>

          <div className="fpControls">
            <div className="dv-chips fpChips">
              {typeOptions.map((t) => (
                <button
                  key={t}
                  type="button"
                  className={`dv-chip ${t === activeCategory2 ? "dv-chip--active" : ""}`}
                  onClick={() => {
                    setActiveCategory2(t);
                    setShowAll2(false);
                  }}
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="fpSearchWrap">
              <img
                src={searchIcon}
                alt="Search"
                className="fpSearchIconImg"
                draggable={false}
              />
              <input
                value={searchQuery2}
                onChange={(e) => setSearchQuery2(e.target.value)}
                placeholder="Search Projects.."
                className="fpSearchInput"
              />
            </div>
          </div>

          <div className="fpGrid">
            {(showAll2 ? filtered : filtered.slice(0, 6)).map((item, idx) => (
              <FeaturedCard
                key={item.id}
                item={item}
                onOpenProject={() => handleOpenProject(item)}
                onOpenVizdom={() => handleOpenVizdom(item)}
                onOpenYoutube={() =>
                  openVideo(
                    item.youtube,
                    item.name || "Project Walkthrough",
                    "Offline-ready project walkthrough",
                    { type: "youtube" }
                  )
                }
                onOpenDemo={() =>
                  openVideo(
                    item.demoLink,
                    item.name || "Project Demo",
                    "Offline-ready project Demo",
                    { type: "demo" }
                  )
                }
              />
            ))}
          </div>

          {loading ? (
            <div className="fpEmpty">Curating projects for you…</div>
          ) : (
            filtered.length === 0 && (
              <div className="fpEmpty">No projects found matching your criteria.</div>
            )
          )}

          {!showAll2 && filtered.length > 6 && (
            <div className="fpBottom">
              <button
                type="button"
                className="fpViewAllLink"
                onClick={() => navigate(`/${currentRegion}/showcase`)}
              >
                View All Projects <span>↗</span>
              </button>
            </div>
          )}
        </div>
      </section>

      <TestimonialsOnly />
      <Footer />
    </div>
  );
}

/** ====== STYLES ====== */
const sx = {
  page: {
    minHeight: "100vh",
    background: "#ffffff",
    color: "#141414",
    fontFamily: "var(--font-sans)",
  },
};